import { CONFIG } from '../config.js';

const PU_NAMES = { magnet: '¡Imán!', shield: '¡Escudo!', sprint: '¡Sprint!' };

/**
 * Marcador de la partida: puntos, distancia, monedas, potenciadores activos y aviso de peligro.
 * Solo toca el DOM cuando cambia un valor.
 */
export class Hud {
  constructor(root, flash) {
    this.root = root;
    this.flash = flash;
    this.fields = {
      score: root.querySelector('[data-hud=score]'),
      distance: root.querySelector('[data-hud=distance]'),
      coins: root.querySelector('[data-hud=coins]'),
    };
    this.danger = root.querySelector('[data-hud=danger]');
    this.mult = root.querySelector('[data-hud=mult]');
    this.toast = root.querySelector('[data-hud=toast]');
    this.hintEl = root.querySelector('[data-hud=hint]');
    this.powerUps = {};
    for (const el of root.querySelectorAll('[data-pu]')) {
      this.powerUps[el.dataset.pu] = { el, bar: el.querySelector('i'), last: -1 };
    }
    this.last = {};
  }

  show() {
    this.root.hidden = false;
  }

  hide() {
    this.root.hidden = true;
  }

  update(world) {
    this.#set('score', world.score);
    this.#set('distance', `${Math.floor(world.player.distance)} m`);
    this.#set('coins', world.coins);
    const m = world.multiplier;
    if (this.last.mult !== m) {
      this.last.mult = m;
      this.mult.textContent = `x${m}`;
      this.mult.hidden = m <= 1;
    }

    for (const [type, pu] of Object.entries(this.powerUps)) {
      // Fracción restante redondeada al 1 %: evita escribir en el DOM en cada fotograma.
      const left = Math.ceil((world.effects[type] / CONFIG.powerUps[type]) * 100) / 100;
      if (left === pu.last) continue;
      pu.last = left;
      pu.el.hidden = left <= 0;
      pu.bar.style.transform = `scaleX(${left})`;
    }

    const danger = world.chaser.near > 0 && world.player.state === 'running';
    if (this.danger.hidden === danger) this.danger.hidden = !danger;
  }

  /** Destello rojo en los bordes al tropezar. */
  hurt() {
    this.flash.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 450, easing: 'ease-out' });
  }

  /** Texto breve en el centro: potenciador recogido (type) o un mensaje con su clase de color. */
  announce(type, text = PU_NAMES[type], cls = `pu-${type}`) {
    this.toast.textContent = text ?? '';
    this.toast.className = `hud-toast ${cls}`;
    this.toast.animate(
      [
        { opacity: 0, transform: 'translateX(-50%) scale(0.7)' },
        { opacity: 1, transform: 'translateX(-50%) scale(1.1)', offset: 0.2 },
        { opacity: 1, transform: 'translateX(-50%) scale(1)', offset: 0.7 },
        { opacity: 0, transform: 'translateX(-50%) scale(1)' },
      ],
      { duration: 1100, easing: 'ease-out' },
    );
  }

  /** Consejo del tutorial, abajo en el centro. */
  hint(text) {
    this.hintEl.textContent = text;
    this.hintEl.animate(
      [
        { opacity: 0, transform: 'translate(-50%, 10px)' },
        { opacity: 1, transform: 'translate(-50%, 0)', offset: 0.12 },
        { opacity: 1, transform: 'translate(-50%, 0)', offset: 0.8 },
        { opacity: 0, transform: 'translate(-50%, 0)' },
      ],
      { duration: 1900, easing: 'ease-out' },
    );
  }

  #set(key, value) {
    if (this.last[key] === value) return;
    this.last[key] = value;
    this.fields[key].textContent = value;
  }
}
